import React, { useEffect, useState } from "react";
import { Table, Form, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "../../../../style/addrestoration.css";
import "../../../../style/addmaterial.css";
import { apiAxios } from "../../../../utils/apiAxios";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

interface RejectionReason {
  rejectionReasonID: number;
  reasonName: string;
  isActive: boolean;
  createdDate?: string;
  updatedDate?: string;
}

const AddRejectionReason: React.FC = () => {
  const [reasonName, setReasonName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [reasons, setReasons] = useState<RejectionReason[]>([]);
  const [editId, setEditId] = useState<number | null>(null);
  const [editValue, setEditValue] = useState("");
  const [editActive, setEditActive] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);


  const fetchRejectionReasons = async () => {
    try {
      const res = await apiAxios.get (`${API_BASE}/RejectionReason/GetAll`);
       const data = res.data;
      if (data?.isSuccess && Array.isArray(data.singleData)) {
        setReasons([...data.singleData].reverse());
      } else {
        console.error("Unexpected API response format:", data);
        setReasons([]);
      }
    } catch (err) {
      console.error("Error fetching rejection reasons:", err);
      setReasons([]);
    }
  };

  useEffect(() => {
    fetchRejectionReasons();
  }, []);

const handleAdd = async () => {
  const trimmedName = reasonName.trim();

  if (!trimmedName) {
    toast.warning("Please enter rejection reason!");
    return;
  }

  const isDuplicate = reasons.some(
    (r) => r.reasonName.toLowerCase() === trimmedName.toLowerCase()
  );

  if (isDuplicate) {
    toast.warning("Rejection reason already exists!");
    return;
  }

  try {
    const res = await apiAxios.post(`${API_BASE}/RejectionReason/Create`, {
      reasonName: trimmedName,
      isActive,
    });

    const result = res.data;

    if (result.isSuccess) {
      setReasons([result.singleData, ...reasons]);
      toast.success("Added successfully!");
      setReasonName("");
      setIsActive(true);
    } else {
      toast.error(result.status || "Add failed");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};


  const handleEdit = (id: number, name: string, active: boolean) => {
    setEditId(id);
    setEditValue(name);
    setEditActive(active);
  };

const handleUpdate = async () => {
  if (!editValue.trim() || editId === null) return;

  const isDuplicate = reasons.some(
    (r) =>
      r.reasonName.toLowerCase() === editValue.toLowerCase() &&
      r.rejectionReasonID !== editId
  );

  if (isDuplicate) {
    toast.warning("Rejection reason already exists!");
    return;
  }

  try {
    const res = await apiAxios.put(`${API_BASE}/RejectionReason/Update`, {
      rejectionReasonID: editId,
      reasonName: editValue,
      isActive: editActive,
    });

    const result = res.data;

    if (result.isSuccess) {
      setReasons(
        reasons.map((r) =>
          r.rejectionReasonID === editId
            ? { ...r, reasonName: editValue, isActive: editActive }
            : r
        )
      );

      toast.success("Updated successfully!");
      setEditId(null);
    }
  } catch {
    toast.error("Update failed");
  }
};

  const handleCancel = () => {
    setEditId(null);
    setEditValue("");
    setEditActive(true);
  };


  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

const handleDelete = async () => {
  if (deleteId === null) return;

  try {
    const res = await apiAxios.delete(
      `${API_BASE}/RejectionReason/Delete/${deleteId}`
    );

    const result = res.data;

    if (result.isSuccess) {
      setReasons(reasons.filter((r) => r.rejectionReasonID !== deleteId));
      toast.success("Deleted successfully!");
    }
  } catch {
    toast.error("Delete failed");
  } finally {
    setShowDeleteModal(false);
    setDeleteId(null);
  }
};

  return (
    <div className="mt-1">

      <h4 className="mb-4"> Add Rejection Reason</h4>

      <div className="premium-card  mt-3">


        <label className="form-label">Add New Rejection Reason</label>
        <Row className="mb-2">
          <Col md={12}>
            <Form.Control
              type="text"
              placeholder="Enter Rejection Reason"
              value={reasonName}
              onChange={(e) => setReasonName(e.target.value)}
            />
          </Col>

        </Row>
        <Row>
          <Col className="text-start mt-2">
            <button type="submit" className="btn py-2 px-3 btn-primary" onClick={handleAdd}>
              Add Reason
            </button>
          </Col>
        </Row>
      </div>

      <div className="premium-card  mt-5">

       <h5 className="mb-3"> Rejection Reason List </h5>
        <Table bordered hover responsive className="align-middle addshade-table2 mb-0 custom-material-table">
          <thead className="table-light">
            <tr>
              <th style={{ width: "80px" }}>ID</th>
              <th>Reason Name</th>
              <th style={{ width: "100px" }}>Status</th>
              <th style={{ width: "250px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {reasons.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted">
                  No rejection reasons added yet
                </td>
              </tr>
            ) : (
              reasons.map((item) => (
                <tr key={item.rejectionReasonID}>
                  <td>{item.rejectionReasonID}</td>
                  <td>
                    {editId === item.rejectionReasonID ? (
                      <Form.Control
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                      />
                    ) : (
                      <span className="font-weight500">{item.reasonName}</span>
                    )}
                  </td>
                  <td>
                    {editId === item.rejectionReasonID ? (
                      <Form.Check
                        type="checkbox"
                        checked={editActive}
                        onChange={(e) => setEditActive(e.target.checked)}
                      />
                    ) : (
                      <span className={`badge ${item.isActive ? 'bg-success' : 'bg-danger'}`}>
                        {item.isActive ? 'Active' : 'Inactive'}
                      </span>
                    )}
                  </td>
                  <td>
                    {editId === item.rejectionReasonID ? (
                      <div className="d-flex justify-content-center gap-2">
                        <div className="action-btn delete custom-edit-icon"

                          onClick={handleUpdate}
                        >
                          <i className="bi bi-check-lg" title="Update"></i>
                        </div>
                        <div className="action-btn delete custom-edit-icon"

                          onClick={handleCancel}
                        >
                          <i className="bi bi-x-lg" title="Cancel"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center gap-2">
                        <div className="action-btn delete custom-edit-icon"

                          onClick={() =>
                            handleEdit(item.rejectionReasonID, item.reasonName, item.isActive)
                          }
                        >
                          <i className="bi bi-pencil-square" title="Edit"></i>
                        </div>
                        <div className="action-btn delete custom-edit-icon"

                          onClick={() => confirmDelete(item.rejectionReasonID)}
                        >
                          <i className="bi bi-trash" title="Delete"></i>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>


      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        dialogClassName="custom-top-modal"
      >
        <Modal.Body className="text-center">
          <p className="fs-6">Are you sure you want to delete this rejection reason?</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button type="button" className="btn py-2 px-3 btn-primary" onClick={handleDelete}>
            Yes
          </button>
          <button type="button" className="btn py-2 px-3 btn-secondary" onClick={() => setShowDeleteModal(false)}>
            No
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddRejectionReason;